import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { FiMenu, FiX } from "react-icons/fi";
import { useState, useEffect } from "react";

type MenuType =
  | "oczyszczanie-terenu"
  | "prace-ziemne"
  | "zakladanie-ogrodow"
  | null;

const Header: React.FC = () => {
  const [activeMenu, setActiveMenu] = useState<MenuType>(null);
  const [delayedMenu, setDelayedMenu] = useState<MenuType>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);

  useEffect(() => {
    if (activeMenu) {
      setDelayedMenu(activeMenu);
    } else {
      const timer = setTimeout(() => setDelayedMenu(null), 200);
      return () => clearTimeout(timer);
    }
  }, [activeMenu]);

  const handleMouseEnter = (menu: MenuType) => {
    setActiveMenu(menu);
  };

  const handleMouseLeave = () => {
    setActiveMenu(null);
  };

  return (
    <>
      {/* Desktop Header */}
      <header className="hidden lg:flex flex-col absolute z-50 w-full">
        <div className="w-full bg-green flex flex-row items-center justify-between px-12 py-2 text-lg">
          <div className="flex flex-row items-center justify-start gap-2">
            <a
              href="tel:+48604351852"
              className="hover:opacity-50 transition duration-300 ease-linear flex flex-row items-center text-white gap-2 justify-start"
            >
              <FaPhoneAlt />
              <span>+48 604 351 852</span>
            </a>
            <a
              href="mailto:kontakt@drzewus.pl"
              className="hover:opacity-50 transition duration-300 ease-linear flex flex-row items-center text-white gap-2 justify-start"
            >
              <IoMail />
              <span>kontakt@drzewus.pl</span>
            </a>
          </div>
        </div>
        <div className="w-full flex flex-col items-center justify-start">
          <div className="w-4/5 rounded-b-xl py-4 px-6 bg-white shadow-lg flex flex-row items-center justify-between">
            <a
              href="/"
              className="text-4xl font-head color-green font-semibold"
            >
              Drzewus
            </a>
            <nav className="relative flex flex-row items-center justify-end gap-6">
              <div
                onMouseEnter={() => handleMouseEnter("oczyszczanie-terenu")}
                onMouseLeave={handleMouseLeave}
                className="relative"
              >
                <a
                  href="#"
                  className="color-green hover:opacity-50 transition duration-300 ease-linear"
                >
                  Oczyszczanie terenu
                </a>
                {delayedMenu === "oczyszczanie-terenu" && (
                  <div className="absolute top-full mt-2 shadow-xl bg-white p-6 rounded-xl text-left flex flex-col items-start justify-start gap-2 min-w-[275px]">
                    <a
                      href="/oczyszczanie-terenu/mulczer-lesny"
                      className="block color-green hover:opacity-50 transition duration-300 ease-linear"
                    >
                      Mulczer leśny
                    </a>
                    <a
                      href="/oczyszczanie-terenu/wycinka-klasyczna"
                      className="block color-green hover:opacity-50 transition duration-300 ease-linear"
                    >
                      Wycinka drzew - klasyczna
                    </a>
                    <a
                      href="/oczyszczanie-terenu/wycinka-alpinistyczna"
                      className="block color-green hover:opacity-50 transition duration-300 ease-linear"
                    >
                      Wycinka drzew - alpinistyczna
                    </a>
                  </div>
                )}
              </div>
              <div
                onMouseEnter={() => handleMouseEnter("prace-ziemne")}
                onMouseLeave={handleMouseLeave}
                className="relative"
              >
                <a
                  href="#"
                  className="color-green hover:opacity-50 transition duration-300 ease-linear"
                >
                  Prace ziemne
                </a>
              </div>
              <div
                onMouseEnter={() => handleMouseEnter("zakladanie-ogrodow")}
                onMouseLeave={handleMouseLeave}
                className="relative"
              >
                <a
                  href="#"
                  className="color-green hover:opacity-50 transition duration-300 ease-linear"
                >
                  Zakładanie ogrodów
                </a>
              </div>
              <a
                href="/ogrodzenia"
                className="color-green hover:opacity-50 transition duration-300 ease-linear"
              >
                Ogrodzenia
              </a>
              <a
                href="/o-nas"
                className="color-green hover:opacity-50 transition duration-300 ease-linear"
              >
                O nas
              </a>
              <a
                href="/faq"
                className="color-green hover:opacity-50 transition duration-300 ease-linear"
              >
                FAQ
              </a>
              <a href="/kontakt">
                <button className="button-green">Bezpłatna wycena</button>
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Mobile Header */}
      <header className="block lg:hidden fixed z-[999999999] w-full bg-white shadow-md">
        <div className="flex flex-row items-center justify-between px-4 py-4">
          <a href="/" className="text-3xl font-head color-green font-semibold">
            Drzewus
          </a>
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-green text-3xl"
          >
            {mobileMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="w-full fixed inset-0 bg-black bg-opacity-70 z-40">
            <div className="bg-white w-[85%] max-w-[400px] h-full fixed right-0 top-0 shadow-xl flex flex-col items-center py-6 gap-6">
              <nav className="flex flex-col items-center gap-4 text-xl">
                <a href="/" className="color-green hover:opacity-50">
                  Strona główna
                </a>
                <a
                  href="/oczyszczanie-terenu"
                  className="color-green hover:opacity-50"
                >
                  Oczyszczanie terenu
                </a>
                <a
                  href="/prace-ziemne"
                  className="color-green hover:opacity-50"
                >
                  Prace ziemne
                </a>
                <a
                  href="/zakladanie-ogrodu"
                  className="color-green hover:opacity-50"
                >
                  Zakładanie ogrodów
                </a>
                <a href="/ogrodzenia" className="color-green hover:opacity-50">
                  Ogrodzenia
                </a>
                <a href="/o-nas" className="color-green hover:opacity-50">
                  O nas
                </a>
                <a href="/faq" className="color-green hover:opacity-50">
                 FAQ
                </a>
                <a href="/kontakt">
                  <button className="button-green">Bezpłatna wycena</button>
                </a>
              </nav>

              <div className="w-full border-t border-gray-300 pt-4">
                <div className="flex flex-col items-center gap-3">
                  <a
                    href="tel:+48604351852"
                    className="flex items-center gap-2 text-green"
                  >
                    <FaPhoneAlt /> <span>+48 604 351 852</span>
                  </a>
                  <a
                    href="mailto:kontakt@drzewus.pl"
                    className="flex items-center gap-2 text-green"
                  >
                    <IoMail /> <span>kontakt@drzewus.pl</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>
      <div className="fixed right-0 top-[40vh] flex flex-col bg-white shadow-xl rounded-l-xl z-[999999] gap-2 p-2 border border-l-green-800 border-y-green-800">
        <a
          href="https://www.facebook.com/drzewuspomorskie"
          className="text-2xl text-green hover:opacity-50 transition duration-300 ease-linear cursor-pointer"
          target="_blank"
        >
          <img
            src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/fb-logo.png"
            alt="Facebook - Drzewus Pomorskie"
            className="w-12"
          />
        </a>
      </div>
    </>
  );
};

export default Header;
